import { z } from 'zod';

export const memberDtoSchema = z.object({
  membershipId: z.string().uuid(),
  userId: z.string().uuid(),
  email: z.string().email(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  fullName: z.string().nullable(),
  roleId: z.string().uuid(),
  roleName: z.string(),
  isInvitePending: z.boolean(),
  isActive: z.boolean(),
  joinedAt: z.string(),
});

export type MemberDto = z.infer<typeof memberDtoSchema>;

export const pagedResultSchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z.object({
    items: z.array(itemSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalPages: z.number(),
  });

export const inviteMemberSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Enter a valid email'),
  roleId: z.string().uuid('Please select a role'),
});

export type InviteMemberInput = z.infer<typeof inviteMemberSchema>;
